<app-q-modal>
  <ng-container slot="header">
    {{ "remove_contact" | translate }}
  </ng-container>
  <ng-container slot="body">
    <ng-container *ngIf="status === 'success'; else formView">
      <div class="result-message result-message--success">
        {{
          (action === "anonymize"
            ? "remove_contact_anonymize_success"
            : "remove_contact_deactivate_success"
          ) | translate
        }}
      </div>
    </ng-container>

    <ng-template #formView>
      <form [formGroup]="form" class="form-container">
        <app-q-segmented-controls
          formControlName="action"
          [controls]="actions"
          [inline]="false"
        ></app-q-segmented-controls>

        <p class="description">
          {{
            (action === "anonymize"
              ? "remove_contact_anonymize_description"
              : "remove_contact_deactivate_description"
            ) | translate
          }}
        </p>

        <app-q-input
          formControlName="confirmName"
          [label]="'remove_contact_confirm' | translate : { name: contactName }"
          [placeholder]="contactName"
        ></app-q-input>

        <div
          *ngIf="status === 'failed'"
          class="result-message result-message--failed"
        >
          {{ "remove_contact_failed" | translate }}
        </div>
      </form>
    </ng-template>
  </ng-container>
  <ng-container slot="actions">
    <div class="actions-container">
      <ng-container *ngIf="status === 'success'; else formActions">
        <app-q-button
          (click)="closeModal()"
          buttonType="save"
          label="close"
        ></app-q-button>
      </ng-container>
      <ng-template #formActions>
        <app-q-button
          (click)="closeModal()"
          buttonType="cancel"
          label="cancel"
          classes="margin-right"
          [disabled]="status === 'working'"
        ></app-q-button>
        <app-q-button
          (click)="submit()"
          buttonType="remove"
          [label]="
            action === 'anonymize'
              ? 'remove_contact_anonymize'
              : 'remove_contact_deactivate'
          "
          [isLoading]="status === 'working'"
          [disabled]="!nameMatches || status === 'working'"
        ></app-q-button>
      </ng-template>
    </div>
  </ng-container>
</app-q-modal>
